// Generated by ReScript, PLEASE EDIT WITH CARE


let baseRoute = "/analytics";

let overviewRoute = baseRoute + "/overview";

let shopsRoute = baseRoute + "/shops";

let topPerformingProductsRoute = baseRoute + "/top-performing-products";

let topPerformingStaffsRoute = baseRoute + "/top-performing-staff";

let cashFlowRoute = baseRoute + "/cash-flow";

export {
  baseRoute,
  overviewRoute,
  shopsRoute,
  topPerformingProductsRoute,
  topPerformingStaffsRoute,
  cashFlowRoute,
}
/* No side effect */
